import { Provider, ModuleWithProviders } from '@angular/core';
import { DwIframeFinereportInfoService } from './service/iframe-finereport-info.service';
import { DwIframeFinereportService } from './service/iframe-finereport.service';
import { DwIframeGeneralInfoService } from './service/iframe-general-info.service';
import { DwIframeGeneralService } from './service/iframe-general.service';
import { DwIframeFrSignService } from './service/iframe-fr-sign.service';
var DwIframeModule = /** @class */ (function () {
    function DwIframeModule() {
    }
    // 寫在 forRoot 裡的 providers, 表示要提供給上層做管理, 在 [DwIframeModule] 的 [declarations] 是無法使用, 除非上層有 import.
    // 上層也需要使用 forRoot 才能做調用, 調用時, 是調用 [DwIframeModule].
    DwIframeModule.forRoot = function (providers) {
        return {
            ngModule: DwIframeModule,
            providers: [
                DwIframeFrSignService,
                DwIframeFinereportInfoService,
                DwIframeFinereportService,
                DwIframeGeneralInfoService,
                DwIframeGeneralService
            ].concat(providers)
        };
    };
    return DwIframeModule;
}());
export { DwIframeModule };
